import { observer } from 'mobx-react';
import React from 'react';

import store from 'stores/RootStore';

import FiltersToolbarButton from './FiltersToolbarButton';

function SaveActiveFilterSetButton() {
  const store_creative = store.creative;
  const filterManager = store_creative?.ads.filter;

  const saveChanges = async () => {
    await store_creative?.save();
  };

  // Only a saved filter can be saved over; the scratch one has to be named
  // first, which is what NewFilterSetButton is for.
  const canSave = store_creative && filterManager && !filterManager.isScratch;

  return (
    <FiltersToolbarButton
      disabled={!canSave}
      label="Save"
      onClick={saveChanges}
    />
  );
}

export default observer(SaveActiveFilterSetButton);
